"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const Info_1 = __importDefault(require("@material-ui/icons/Info"));
const react_1 = __importStar(require("react"));
const lib_1 = require("../../lib");
const InfoModal_1 = __importDefault(require("../Modals/InfoModal"));
const context_1 = __importDefault(require("./context"));
const Checkbox_1 = __importDefault(require("./input/Checkbox"));
const ComboBox_1 = __importDefault(require("./input/ComboBox"));
const DateTime_1 = __importDefault(require("./input/DateTime"));
const Default_1 = __importDefault(require("./input/Default"));
const File_1 = __importDefault(require("./input/File"));
const Hidden_1 = __importDefault(require("./input/Hidden"));
const Image_1 = __importDefault(require("./input/Image"));
const List_1 = __importDefault(require("./input/List"));
const Select_1 = __importDefault(require("./input/Select"));
function convertValue(value, type) {
    switch (type) {
        case 'number':
            return value === '' ? '' : +(value || 0);
        default:
            return value;
    }
}
function strip(value) {
    const newObj = Object.assign({}, value);
    delete newObj.__typename;
    delete newObj.syntheticId;
    return newObj;
}
function needsStripping(value) {
    return value.syntheticId || value.__typename;
}
// TODO deep check
function stripSyntheticIds(obj) {
    return Object.keys(obj).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: Array.isArray(obj[key])
            ? obj[key].map((value) => needsStripping(value) ? strip(value) : value)
            : obj[key] })), {});
}
// these values are used for change detection
const defaultProps = { defaultValue: {} };
const DVKForm = ({ className, children, bottomContent, defaultValue = defaultProps.defaultValue, fields, ContentWrapper = react_1.Fragment, ActionsWrapper = react_1.Fragment, renderActions = null, onSubmit = () => null, onChange = () => null, invalidFields = null, InputModal = react_1.Fragment, }) => {
    const [obj, setObj] = react_1.useState(Object.assign({}, defaultValue));
    const [innerInvalidFields, setInnerInvalidFields,] = react_1.useState(null);
    const formId = react_1.useMemo(() => {
        setObj(Object.assign({}, defaultValue));
        return lib_1.uuid();
    }, [defaultValue]);
    const { isOpen: isInfoModalOpen, data: infoModalData, open: openInfoModal, close: closeInfoModal, } = lib_1.useModal();
    react_1.useEffect(() => {
        onChange(obj);
    }, [obj, onChange]);
    function handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        const requiredFields = fields.filter((it) => it.required);
        const requiredErrors = requiredFields
            .map((it) => [it.name, lib_1.deepGet(obj, it.name)])
            .filter(([, value]) => value === null ||
            value === undefined ||
            value.length === 0);
        if (requiredErrors.length) {
            setInnerInvalidFields(requiredErrors.reduce((acc, it) => (Object.assign(Object.assign({}, acc), { [it[0]]: 'required' })), {}));
        }
        else {
            setInnerInvalidFields(null);
            onSubmit(stripSyntheticIds(obj));
        }
    }
    const updateProperty = (property, type) => (event) => {
        let value;
        switch (type) {
            case 'date':
            case 'time':
            case 'date-time':
            case 'image':
            case 'file':
                value = event;
                break;
            case 'combo-box':
                value = event ? event.name || event : null;
                break;
            case 'checkbox':
                value = event.target.checked;
                break;
            default:
                value = event.target.value;
        }
        setObj((oldObj) => {
            const newObject = Object.assign({}, oldObj);
            lib_1.deepSet(newObject, property, convertValue(value, type));
            return newObject;
        });
        if (innerInvalidFields && innerInvalidFields[property]) {
            setInnerInvalidFields((oldInvalidFields) => (Object.assign(Object.assign({}, oldInvalidFields), { [property]: false })));
        }
    };
    const updatePropertyF = (property, update) => {
        setObj((oldObj) => {
            const newObject = Object.assign({}, oldObj);
            lib_1.deepSet(newObject, property, update(lib_1.deepGet(oldObj, property)));
            return newObject;
        });
        if (innerInvalidFields && innerInvalidFields[property]) {
            setInnerInvalidFields((oldInvalidFields) => (Object.assign(Object.assign({}, oldInvalidFields), { [property]: false })));
        }
    };
    function getErrorMessage(errorMessageCode, errorMessage) {
        if (!errorMessageCode)
            return;
        if (errorMessageCode === 'required' &&
            !(errorMessage && errorMessage['required'])) {
            return 'Please fill out this field';
        }
        if (typeof errorMessage === 'string')
            return errorMessage;
        const code = typeof errorMessageCode === 'string' ? errorMessageCode : 'default';
        if (!errorMessage && typeof errorMessageCode !== 'string')
            return 'Invalid value';
        if (!errorMessage)
            return code;
        return errorMessage[code];
    }
    function renderInputField({ name, label, type, errorMessage, 
    // default
    required, autoFocus, disabled, multiline, autoComplete, inputProps, 
    //file
    acceptedFileType, multiple, 
    // select
    values, 
    // list
    fields, newLabel, editLabel, deleteLabel, deleteMessage, accordionProps, 
    // checkbox
    text, checkboxProps, 
    // combo-box
    options, renderOption, search, }) {
        const errorMessageCode = (innerInvalidFields && innerInvalidFields[name]) ||
            (invalidFields && invalidFields[name]);
        const message = getErrorMessage(errorMessageCode, errorMessage);
        const commonProps = {
            key: name,
            name,
            label,
            type,
        };
        const errorProps = {
            hasError: !!errorMessageCode,
            message,
        };
        switch (type) {
            case 'list':
                return (react_1.default.createElement(List_1.default, Object.assign({}, commonProps, { fields: fields, newLabel: newLabel, editLabel: editLabel, deleteLabel: deleteLabel, deleteMessage: deleteMessage, accordionProps: accordionProps, InputModal: InputModal })));
            case 'select':
                return (react_1.default.createElement(Select_1.default, Object.assign({}, commonProps, { values: values, required: required, autoFocus: autoFocus, disabled: disabled }, errorProps)));
            case 'date':
            case 'time':
            case 'date-time':
                return (react_1.default.createElement(DateTime_1.default, Object.assign({}, commonProps, { required: required, disabled: disabled }, errorProps)));
            case 'image':
                return (react_1.default.createElement(Image_1.default, Object.assign({}, commonProps, { required: required, disabled: disabled, autoFocus: autoFocus }, errorProps)));
            case 'file':
                return (react_1.default.createElement(File_1.default, Object.assign({}, commonProps, { required: required, disabled: disabled, acceptedFileType: acceptedFileType, multiple: multiple }, errorProps)));
            case 'checkbox':
                return (react_1.default.createElement(Checkbox_1.default, Object.assign({}, commonProps, { required: required, disabled: disabled, text: text, checkboxProps: checkboxProps }, errorProps)));
            case 'hidden':
                return react_1.default.createElement(Hidden_1.default, Object.assign({}, commonProps));
            case 'combo-box':
                return (react_1.default.createElement(ComboBox_1.default, Object.assign({}, commonProps, { multiple: multiple, required: required, autoFocus: autoFocus, disabled: disabled, options: options, renderOption: renderOption, search: search }, errorProps)));
            default:
                return (react_1.default.createElement(Default_1.default, Object.assign({}, commonProps, { autoFocus: autoFocus, autoComplete: autoComplete, multiline: multiline, required: required, disabled: disabled, inputProps: inputProps }, errorProps)));
        }
    }
    function renderInputBox(field) {
        return (react_1.default.createElement(core_1.Box, { key: field.name, display: "flex", style: field.type === 'hidden' ? { display: 'none' } : {} },
            react_1.default.createElement(core_1.Box, { flexGrow: 1 }, renderInputField(field)),
            field.infoModal && (react_1.default.createElement(core_1.Box, { display: "flex", justifyContent: "center", flexDirection: "column" },
                react_1.default.createElement(core_1.IconButton, Object.assign({ size: "medium" }, (field.infoModal.buttonProps || {}), { onClick: () => openInfoModal({
                        message: field.infoModal.message,
                        title: field.infoModal.title,
                    }) }),
                    react_1.default.createElement(Info_1.default, null))))));
    }
    return (react_1.default.createElement("form", { key: formId, id: formId, className: className, onSubmit: handleSubmit },
        react_1.default.createElement(ContentWrapper, null,
            react_1.default.createElement(context_1.default.Provider, { value: {
                    obj,
                    updateProperty,
                    updatePropertyF,
                } },
                children,
                fields
                    .map((field) => renderInputBox(field))
                    .reduce((acc, it) => acc.concat(it), []),
                bottomContent,
                react_1.default.createElement(InfoModal_1.default, { onClose: closeInfoModal, open: isInfoModalOpen, message: (infoModalData && infoModalData.message) || '', title: (infoModalData && infoModalData.title) || '' }))),
        react_1.default.createElement(ActionsWrapper, null, renderActions &&
            typeof renderActions === 'function' &&
            renderActions(formId)),
        react_1.default.createElement("button", { type: "submit", style: { display: 'none' }, form: formId })));
};
exports.default = DVKForm;
//# sourceMappingURL=index.js.map